import { Heading, InlineFeedback, Text } from '@zillow/constellation';
import { FIELD_IDS, getFields } from '../../../../constants/wizard';
import { useFormContext } from 'react-hook-form';
import { isFieldOptional } from '../../../../utils/overview/overview-statuses';
import { useFeatureFlags } from '../../../../contexts/ApplicationContext';

export function PaymentRequestOverview() {
  const { watch } = useFormContext() ?? {};
  const featureFlags = useFeatureFlags();
  const answer = watch?.(FIELD_IDS.REQUEST_ZILLOW_PAYMENTS);
  const field = getFields(featureFlags).find((f) => f.id === FIELD_IDS.REQUEST_ZILLOW_PAYMENTS);
  if (!field) return null;

  const isOptional = isFieldOptional(field, featureFlags);
  return (
    <>
      <Heading level={6} marginY="xs">
        If accepted, ask landlord to use Zillow payments
      </Heading>
      {answer == null && !isOptional ? (
        <InlineFeedback appearance="warning">Needs info</InlineFeedback>
      ) : (
        <Text>{answer ? 'Yes' : 'No'}</Text>
      )}
    </>
  );
}
